import {
  Component,
  Injector,
  ChangeDetectorRef
} from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';

@Component({
  selector: 'app-activities-add-button',
  templateUrl: './activities-add-button.component.html',
  styleUrls: ['./activities-add-button.component.scss'],
})
export class ActivitiesAddButtonComponent extends AppComponentBase {

  constructor(
    injector: Injector
    ) {
        super(injector);
    }

ngAfterViewInit() {}

}
